export class Site {
 public   site = {
    'active': true,
    'groupId': '',
    'ePeopleIdString': '',
    'ePeopleIdNumber': '',
    'organizationId': '',
    'siteDetails': {
        'company': {
            'id': '',
            'name': ''
        },
        'siteName': '',
        'siteId': '',
        'siteType': '',
        'sitePurpose': '',
        'sitePurposeOrderNumber': '',
        'physicalAddress': {
            'address1': '',
            'address2': '',
            'address3': '',
            'zip': '',
            'city': '',
            'state': '',
            'country': ''
        },
        'currentLocation': {
            'address1': '',
            'address2': '',
            'address3': '',
            'zip': '',
            'city': '',
            'state': '',
            'country': ''
        },
        'cityOfReference': '',
        'consolidatedSiteName': '',
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'lastValidatedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'validated': ''
    },
    'siteAddressDetails': {
        'physicalAddress': {
            'address1': '',
            'address2': '',
            'address3': '',
            'zip': '',
            'city': '',
            'state': '',
            'country': ''
        },
        'currentLocation': {
            'address1': '',
            'address2': '',
            'address3': '',
            'zip': '',
            'city': '',
            'state': '',
            'country': ''
        },
        'cityOfReference': '',
        'gpsCoordinates': {
            'lat': 0,
            'long': 0
        },
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': {}
        },
        'lastValidatedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'validated': 1
    },
    'contactDetails': {
        'contactNumber1': '',
        'contactNumber2': '',
        'faxNumber': '',
        'email': '',
        'size': '',
        'sizeUnit': '',
        'siteLeader': {
            'name': '',
            'groupId': '',
            'id': ''
        },
        'digitalAddress': '',
        'consignmentId': '',
        'customerName': '',
        'gpsCoordinates': {
            'lat': '',
            'long': ''
        },
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'lastValidatedBy': {
            'name': '',
            'id': '',
            'time': ''
        },
        'validated': ''
    },
    'lastEdited': [
        {
            'name': '',
            'id': '',
            'time': ''
        }
    ],
    'lastArchivedBy': {
        'name': '',
        'id': '',
        'time': ''
    },
    'lastArchived': [{
        'name': '',
        'id': '',
        'time': ''
    }],
    'companySiteLink': '',
    'created': ''};
}

